import React, {Component} from 'react';
import PropTypes from 'prop-types';
import ManageUserSapAccount from "./ManageUserSapAccount";
import {saveUserSapAccount} from "../../requests/UserRequests";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome/index.es";
import {connect} from "react-redux";

class LinkedSapAccounts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      account: null,
      accounts: [],
    };
    this.addNewAccount = this.addNewAccount.bind(this);
    this.editAccount = this.editAccount.bind(this);
    this.deleteAccount = this.deleteAccount.bind(this);
    this.close = this.close.bind(this);
  }
  
  componentDidMount() {
    if(this.props.accounts){
      this.setState({
        accounts: this.props.accounts
      });
    } else {
      this.refreshAccounts();
    }
  }

  addNewAccount() {
    let accountType = "";
    if(this.props.accountTypes.length === 1){
      accountType = this.props.accountTypes[0].AccountTypeId;
    }
    this.setState({
      account: {
        primaryAcct: '',
        accountTypeId: accountType,
        SalesOrganization: this.props.defaults.account.sales_organization,
        companyCode: '',
        division: this.props.defaults.account.division,
        distributionChannel: this.props.defaults.account.distribution_channel,
      }
    });
  }

  close() {
    this.setState({account: null});
  }

  refreshAccounts() {
    this.props.getAccounts(this.props.userId).then(accounts => {
      this.setState({accounts: accounts});
    })
  }

  editAccount(account) {
    this.setState({account: account});
  }

  deleteAccount(account) {
    this.props.deleteAccount(this.props.userId, account).then(() => {
      if (this.state.account && (this.state.account.AccountId === account.AccountId)) {
        this.setState({account: null});
      }
      this.refreshAccounts();
    });
  }


  render() {
    return (
      <div className="card">
        <div className="row">
          <div className="col-12">
            <div className="row justify-content-between">
              <h3>Linked SAP Accounts</h3>
            </div>
          </div>
        </div>
        <div className="row no-gutters">
          <div className="col-12 col-md-6">
            {this.state.accounts.map((account) =>
              <div key={account.AccountId} className={"row"}>
                <div className="col-6">
                  {account.PrimaryAcct}-{account.CompanyCode}-{account.SalesOrganization}-{account.DistributionChannel}-{account.Division}
                </div>
                <div className="col-6 flex-row d-flex">
                  <span role={"button"} className={"font-button-icon"}
                        onClick={() => this.deleteAccount(account)}><FontAwesomeIcon
                    icon={"trash"}/> Delete</span>
                  <span role={"button"} className={"font-button-icon"}
                        onClick={() => this.editAccount(account)}><FontAwesomeIcon icon={"edit"}/> Edit</span>
                </div>
              </div>
            )}
            <div className="d-flex justify-content-center m-4">
              <button className="btn btn-primary" onClick={this.addNewAccount}>Add Account</button>
            </div>
          </div>
          <div className="col-12 col-md-6">
            {this.state.account && <div className={"modify-section"}>
              <span className={"float-right font-button-icon top-right"} onClick={this.close}>
                <FontAwesomeIcon icon={"times"}/>
              </span>
              <ManageUserSapAccount account={this.state.account} accountTypes={this.props.accountTypes}
                                    saveAccount={(account) => {
                                      return saveUserSapAccount(this.props.userId, account).then(() => {
                                        this.refreshAccounts();
                                        this.setState({account: null});
                                      });
                                    }}/></div>}
          </div>
        </div>
      </div>
    );
  }
}

LinkedSapAccounts.propTypes = {
  userId: PropTypes.number.isRequired,
  getAccounts: PropTypes.func.isRequired,
  deleteAccount: PropTypes.func.isRequired,
};
LinkedSapAccounts.defaultProps = {
  accountTypes: [],
};
export default connect(state => ({
    defaults: state.app.config.defaults
  })
)(LinkedSapAccounts);
